<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="dashboard-tags">
        <breadcrumb title="Manage Project Tags"></breadcrumb>
        <v-container>
            <v-row justify-xl="center">
                <v-col xl="10">
                    <v-card>
                        <v-toolbar
                            flat
                            color="primary"
                            dark>
                            <v-toolbar-title>
                                <v-icon>comment</v-icon> Project Tags
                            </v-toolbar-title>
                            <template v-if="!isMobilePort">
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="accent2"
                                    @click="openModal(null)">
                                    Add Project Tag
                                </v-btn>
                            </template>
                        </v-toolbar>
                        <v-card-text class="pa-0">
                            <template>
                                <v-container>
                                    <v-row
                                        dense
                                        justify="center"
                                        v-if="isMobilePort">
                                        <v-col class="text-center">
                                            <v-btn
                                                dark
                                                color="accent2"
                                                block
                                                @click="openModal(null)">
                                                Add Project Tag
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                                <v-data-table
                                    ref="tagsDataTable"
                                    class="ma-0"
                                    must-sort
                                    :headers="headers"
                                    :items="tags"
                                    :loading="loading"
                                    :items-per-page="itemsPerPage[0]"
                                    :footer-props="{
                                        itemsPerPageOptions: itemsPerPage
                                    }"
                                    :custom-sort="customSort"
                                    @update:options="onTableOptionsUpdate">

                                    <template v-slot:item="{ item, index }">
                                        <tr>
                                            <td>
                                                <a href="#" @click.prevent="goToRoute('notes',{tagId: item.id})"
                                                    :title="`View all Notes for ${item.tag}`"
                                                >
                                                    {{ item.tag }}
                                                </a>
                                            </td>
                                            <td>
                                                <v-avatar
                                                    class="mr-4"
                                                    :color="'#'+item.color"
                                                    size="15">
                                                </v-avatar>
                                                <template v-if="!isMobilePort">#{{item.color}}</template>
                                            </td>
                                            <td
                                                class="text-right area-field-focus">
                                                <template v-if="isTagOwner(item.user) && !isDefaultTag(item.id)">
                                                    <v-tooltip
                                                        left
                                                        max-width="300"
                                                        transition="fade-transition"
                                                        v-model="tooltips.edit[index]">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                class="mr-1"
                                                                color="grey lighten-4"
                                                                fab
                                                                x-small
                                                                dark
                                                                elevation="1"
                                                                v-on="on"
                                                                role="button"
                                                                aria-label="Edit"
                                                                tabindex="0"
                                                                @keyup.enter="showTooltip('edit', index)"
                                                                @keyup.space="showTooltip('edit', index)"
                                                                @click="openModal(item)"
                                                                :class="{'float-right': isMobilePort}">
                                                                <v-icon color="grey darken-1">edit</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span class="tooltip-content"
                                                        @mouseenter="showTooltip('edit', index)"
                                                        @mouseleave="hideTooltip('edit', index)"
                                                        @focus="showTooltip('edit', index)"
                                                        @blur="hideTooltip('edit', index)">Edit {{item.tag}}</span>
                                                    </v-tooltip>
                                                    <v-tooltip
                                                        left
                                                        max-width="300"
                                                        transition="fade-transition"
                                                        v-model="tooltips.delete[index]">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                class="ml-1"
                                                                color="grey lighten-4"
                                                                fab
                                                                x-small
                                                                dark
                                                                elevation="1"
                                                                v-on="on"
                                                                role="button"
                                                                aria-label="Delete"
                                                                tabindex="0"
                                                                @keyup.enter="showTooltip('delete', index)"
                                                                @keyup.space="showTooltip('delete', index)"
                                                                @click="openConfirmModal(item)"
                                                                :class="{'float-right': isMobilePort}">
                                                                <v-icon color="grey darken-1">delete</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span class="tooltip-content"
                                                        @mouseenter="showTooltip('delete', index)"
                                                        @mouseleave="hideTooltip('delete', index)"
                                                        @focus="showTooltip('delete', index)"
                                                        @blur="hideTooltip('delete', index)">Delete {{item.tag}}</span>
                                                    </v-tooltip>
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-results"></template>
                                </v-data-table>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <new-tag-modal></new-tag-modal>
        <v-dialog
            v-model="dialogConfirm"
            width="400"
            persistent>
            <v-card>
<v-card-title :class="{
    primary: true,
    'white--text': true,
    headline: !isMobilePort,
    'caption mobile-title': isMobilePort
  }">
                    Delete Project Tag
                    <v-spacer></v-spacer>
                    <v-icon class="primary white--text" @click="closeConfirmModal">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-expand-transition>
                        <v-row v-show="error">
                            <v-col>
                                <v-alert
                                    class="mb-0"
                                    type="error"
                                    dense>
                                    {{ error }}
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-expand-transition>
                    <v-row>
                        <v-col>
                            <p>
                                Are you sure you want to delete this project tag:
                                <span class="font-weight-bold">{{tagName}}</span>?
                                Any existing notes and bookmarks associated to this project tag will be reassigned to Default project tag.
                            </p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="closeConfirmModal">Cancel</v-btn>
                    <v-btn
                        class="red darken-4 white--text"
                        @click="deleteTag"
                        :loading="saving"
                        :disabled="saving">Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Breadcrumb from '../../content/partials/page_titles';
    import Mobile from '../../inc/mixins/mobile';
    import NewTagModal from "../../content-section/Dialogs/Tag.vue";
    import {EventNames} from "../../../classes/EventNames";
    import DataTableHeadersFocusableByTab from "../../../mixins/accessibility/data-table-headers-focusable-by-tab";

    export default {
        data() {
            return {
                tooltips: {
                    edit: {},
                    delete: {}
                },
                loading: true,
                tagId: 0,
                tags: [],
                error: '',
                tagName: '',
                headers: [
                    {text: 'Tag Name', align: 'start', value: 'tag', width: '45%', sortable: true},
                    {text: 'Color', align: 'start', value: 'color', width: '45%'},
                    {text: '', align: 'right', value: null, sortable: false}
                ],
                itemsPerPage: [10, 20, 30, 50],
                dialogConfirm: false,
                saving: false,
                swr: 'Something went wrong.  Please contact us.',
                sortOptions: {
                    sortBy: 'tag',
                    sortDir: 'asc',
                },
            }
        },
        components: {
            Breadcrumb,
            NewTagModal,
        },
        mixins: [
            Mobile,
            DataTableHeadersFocusableByTab
        ],
        methods: {
            onTableOptionsUpdate(newOptions){
                if (newOptions.sortBy.length) {
                    this.sortOptions.sortBy = newOptions.sortBy[0];
                    this.sortOptions.sortDir = newOptions.sortDesc[0] ? 'desc' : 'asc';
                    this.tags = [];
                    this.getTags();  // Call getTags with direction
                }
            },
            customSort(items){
                return items;
            },
            getTags() {
                this.loading = true;
                const params = this.sortOptions;
                this.$http.get(Routing.generate('get_user_tags'),{params})
                    .then(response => {
                        this.resetTag();
                        this.tags = response.data;
                        this.loading = false;
                    });
            },
            deleteTag() {
                if (!_.isEmpty(this.tagName)) {
                    this.saving = true;
                    this.error = '';
                    this.$http.post(Routing.generate('remove_user_tag'), {id: this.tagId})
                        .then(response => {
                            if (response.data) {
                                this.dialogConfirm = this.saving = false;
                                this.resetTag();
                                this.getTags();
                            } else {
                                this.error = this.swr;
                                this.saving = false;
                            }
                        });
                } else {
                    this.error = this.swr;
                }
            },
            openModal(data) {
                let tagData = null;
                if (!_.isNull(data))
                    tagData = {
                        id: data.id,
                        name: data.tag,
                        color: '#'+data.color,
                        isUpdate: true,
                    };
                EventBus.fire('create-new-tag', tagData);
            },
            openConfirmModal(data) {
                this.tagName = data.tag;
                this.tagId = data.id
                this.dialogConfirm = true;
            },
            closeConfirmModal() {
                this.dialogConfirm = this.saving = false;
                this.resetTag();
            },
            resetTag() {
                this.tagId = 0;
                this.tagName = '';
            },
            isDefaultTag(tagId) {
                return tagId === this.$getConst('defaultTagId');
            },
            isTagOwner(userId) {
                return userId == this.$store.getters.getUser?.id
                    || this.isEnterpriseAdmin
                    || this.isConcurrentAdmin;
            },
            showTooltip(type, index) {
                this.$set(this.tooltips[type], index, true);
            },
            hideTooltip(type, index) {
                this.$set(this.tooltips[type], index, false);
            }
        },
        created() {
            this.getTags();
        },
        mounted() {
            this.$nextTick(() => {
                this.makeTableHeadersFocusableByTab(this.$refs.tagsDataTable.$el);
            });
            EventBus.listen(EventNames.UPDATE_NOTE_TAGS, () => this.getTags());
        }
    }
</script>

<style lang="scss">
    #dashboard-tags {
        table {
            margin: 0;
        }
        .v-data-table-header th.sortable:focus {
            outline: auto;
        }
    }
</style>
